// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2Egse","rootCenter":"LoadMoreObserver_rootCenter__23rlM","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__39k9E"};